import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from 'reboron/DropModal'

import UserAvatar from '../../mini/UserAvatar'
import QuestIcon from '../../mini/QuestIcon'

import {
  unassignmentCancelClick,
  unassignQuestFromUser
} from '../../../actions/assignment'
import { getUserDisplayName } from '../../../utils/name'

export default class UnassignmentModal extends Component {
  constructor(props) {
    super(props)
    this.onUnassignmentClickBound = this.onUnassignmentClick.bind(this)
    this.closeModalBound = this.closeModal.bind(this)
    this.cancelUnassignmentClickBound = this.cancelUnassignmentClick.bind(this)
  }

  componentDidMount () {
    this.showModal()
    document.getElementsByTagName('html')[0].style.overflow = 'hidden'
  }

  componentWillUnmount () {
    document.getElementsByTagName('html')[0].style.overflow = 'scroll'
  }

  render() {
    const modalStyle = {
      maxHeight: 'calc(100% - 100px)',
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      minWidth: '500px',
      background: '#fff',
      overflow: 'visible',
      borderRadius: '6px'
    }

    const contentStyle = {
      backgroundColor: '#fff',
      height: '100%',
      borderRadius: '6px'
    }
    const { quest } = this.props

    return (
      <Modal
        ref="modal"
        className={'unassignment-modal'}
        modalStyle={modalStyle}
        contentStyle={contentStyle}
        closeOnClick={true}
        onHide={this.closeModalBound}
      >
        {quest.assigned_to ? (
          <React.Fragment>
            <div className="top">
              <div className="assignment-icons">
                <QuestIcon
                  icon_image_url={quest.icon_image_url}
                  heightWidth={47}
                />
                <div className="cross-img" />
                <UserAvatar photoUrl={quest.assigned_to.photo_url} />
              </div>
              <h1>Unassign this Quest?</h1>
            </div>
            <div className="bottom">
              <div className="guidance">
                <div>
                  You are about to unassign this quest from{' '}
                  {getUserDisplayName(quest.assigned_to)}.
                </div>
                <div>Are you sure you want to do this?</div>
              </div>
              <div className="actions">
                <div
                  className="button btn-secondary-small modal-cancel"
                  onClick={this.cancelUnassignmentClickBound}
                >
                  Cancel
                </div>
                <div
                  className="button btn-primary-small modal-confirm unassign"
                  onClick={this.onUnassignmentClickBound}
                >
                  Unassign
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : null}
      </Modal>
    )
  }

  async onUnassignmentClick() {
    await this.props.dispatch(
      unassignQuestFromUser(
        this.props.quest.id,
        this.props.questIsAssignedToUser,
        this.props.quest.current_quest_assignment_id
      )
    )
    this.refs.modal.hide()
  }

  showModal() {
    this.refs.modal.show()
  }

  cancelUnassignmentClick() {
    this.refs.modal.hide()
  }

  closeModal() {
    this.props.dispatch(unassignmentCancelClick())
  }
}

UnassignmentModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  quest: PropTypes.object.isRequired,
  questIsAssignedToUser: PropTypes.bool.isRequired
}



// WEBPACK FOOTER //
// ./src/components/quest/assignment/UnassignmentModal.js